import Vue from 'vue';
import 'vue-lite-youtube-embed/style.css';
import App from './App.vue';
import { i18n, vuetify } from './plugins';
import router from './router';
import store from './store';

import BaseDownloadFile from '@/components/BaseDownloadFile.vue';
import BaseDrawerMenuItem from '@/components/BaseDrawerMenuItem.vue';
import BaseErrorAlert from '@/components/BaseErrorAlert.vue';
import BaseFileList from '@/components/BaseFileList.vue';
import BaseFormDragArea from '@/components/BaseFormDragArea.vue';
import BaseFormSelect from '@/components/BaseFormSelect.vue';
import BaseFormTextArea from '@/components/BaseFormTextArea.vue';
import BaseFormTextField from '@/components/BaseFormTextField.vue';
import BaseHeaderBox from '@/components/BaseHeaderBox.vue';
import BaseListItem from '@/components/BaseListItem.vue';
import BaseListItemIconAndAction from '@/components/BaseListItemIconAndAction.vue';
import BaseListLink from '@/components/BaseListLink.vue';
import BaseListRouterLink from '@/components/BaseListRouterLink.vue';
import BaseLoadingLinear from '@/components/BaseLoadingLinear.vue';
import BaseSmallWindow from '@/components/BaseSmallWindow.vue';
import BaseVerifyButton from '@/components/BaseVerifyButton.vue';
import TheAppError from '@/components/TheAppError.vue';
import TheAppLoader from '@/components/TheAppLoader.vue';
import TheDashboardHeader from '@/components/TheDashboardHeader.vue';
import TheLocaleChanger from '@/components/TheLocaleChanger.vue';
import TheThemeToggler from '@/components/TheThemeToggler.vue';
import BaseModalConfirmAction from '@/components/modals/BaseModalConfirmAction.vue';
import BaseModalFeedback from '@/components/modals/BaseModalFeedback.vue';
import BaseModalImage from '@/components/modals/BaseModalImage.vue';
import TheSearchBar from '@/components/search-bar/TheSearchBar.vue';
import { Fragment } from 'vue-frag';

Vue.component('BaseDownloadFile', BaseDownloadFile);
Vue.component('BaseDrawerMenuItem', BaseDrawerMenuItem);
Vue.component('BaseErrorAlert', BaseErrorAlert);
Vue.component('BaseFileList', BaseFileList);
Vue.component('BaseFormDragArea', BaseFormDragArea);
Vue.component('BaseFormSelect', BaseFormSelect);
Vue.component('BaseFormTextArea', BaseFormTextArea);
Vue.component('BaseFormTextField', BaseFormTextField);
Vue.component('BaseHeaderBox', BaseHeaderBox);
Vue.component('BaseListItem', BaseListItem);
Vue.component('BaseListItemIconAndAction', BaseListItemIconAndAction);
Vue.component('BaseListLink', BaseListLink);
Vue.component('BaseListRouterLink', BaseListRouterLink);
Vue.component('BaseLoadingLinear', BaseLoadingLinear);
Vue.component('BaseModalConfirmAction', BaseModalConfirmAction);
Vue.component('BaseModalFeedback', BaseModalFeedback);
Vue.component('BaseModalImage', BaseModalImage);
Vue.component('BaseSmallWindow', BaseSmallWindow);
Vue.component('BaseVerifyButton', BaseVerifyButton);
Vue.component('TheAppError', TheAppError);
Vue.component('TheAppLoader', TheAppLoader);
Vue.component('TheDashboardHeader', TheDashboardHeader);
Vue.component('TheLocaleChanger', TheLocaleChanger);
Vue.component('TheThemeToggler', TheThemeToggler);
Vue.component('TheSearchBar', TheSearchBar);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Fragment', Fragment);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
